import { useSyncExternalStore } from "react";
import type { ICardPaymentMethod } from "../interfaces/payment-method";
import type { UnavailableCardReason } from "./card-funding-availability";

/** In-memory for the tab. A reload asks usage-readiness again. */
let cards = new Map<string, UnavailableCardReason>();
const listeners = new Set<() => void>();

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const blockRailCard = (
  paymentMethodId: string,
  reason: UnavailableCardReason,
): void => {
  const next = new Map(cards);
  next.set(paymentMethodId, reason);
  cards = next;
  emit();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => cards;

export const useBlockedRailCards = (): ReadonlyMap<
  string,
  UnavailableCardReason
> => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

export interface RailUnavailableNotice {
  card: ICardPaymentMethod;
  reason: UnavailableCardReason;
}
